import { render, staticRenderFns } from "./modal-add-email.vue?vue&type=template&id=89fbc528&"
import script from "./modal-add-email.vue?vue&type=script&lang=js&"
export * from "./modal-add-email.vue?vue&type=script&lang=js&"
import style0 from "./modal-add-email.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports